import { useState, useEffect } from 'react';
import { makeRequest } from '../utils';

export default function useAPIData(requestURL, holdRequest, dataChange) {
  const [apiData, setAPIData] = useState();
  useEffect(() => {
    // If the dataChange changes back to false, the data has been written to the db and we want to refresh

    if (
      holdRequest !== true &&
      dataChange !== true &&
      requestURL !== undefined &&
      !requestURL.includes('undefined')
    ) {
      makeRequest(requestURL)
        .then((data) => {
          setAPIData(data);
        })
        .catch((error) => {
          console.error(`Error fetching API data from ${requestURL}: ` + error);
        });
    }
  }, [requestURL, holdRequest, dataChange]);

  return apiData;
}
